<div class="btn-group top-right" [class.show]="isMenuOpen">
  <button
    type="button"
    class="btn btn-outline-dark dropdown-toggle selector-toggle d-flex align-items-center justify-content-between"
    [class.w-100]="!isCollapsed"
    [class.collapsed]="isCollapsed"
    (click)="toggleMenu()"
    (mouseenter)="onMouseEnterButton()"
    (mouseleave)="onMouseLeaveButton()"
    (focus)="onMouseEnterButton()"
    (blur)="onMouseLeaveButton()"
    aria-expanded="isMenuOpen"
    >
    <span class="layer expanded-layer d-flex align-items-center justify-content-between w-100">
      <span class="d-flex align-items-center gap-2 selector-content">
        @if (selectedProject; as proj) {
          @if (proj.logoUrl) {
            <img [src]="proj.logoUrl" alt="logo" class="proj-thumb" />
          } @else {
            <i class="bi bi-image proj-thumb-fallback"></i>
          }
          <span class="proj-name">{{ proj.name }}</span>
        } @else {
          <i class="bi bi-image proj-thumb-fallback"></i>
          <span class="proj-name">Select project</span>
        }
      </span>
      <i class="bi selector-chevron" [ngClass]="isMenuOpen ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
    </span>


  </button>
  <ul class="dropdown-menu dropdown-menu-end" [class.show]="isMenuOpen" [attr.data-bs-popper]="isMenuOpen ? 'static' : null">
    @for (org of organizations(); track org.id) {
      <li class="dropdown-header d-flex align-items-center justify-content-between" (click)="toggleOrg(org.id)">
        <button type="button" class="btn btn-link p-0 d-flex align-items-center gap-2">
          @if (org.logoUrl) {
            <img [src]="org.logoUrl" alt="logo" class="proj-thumb" />
          } @else {
            <i class="bi bi-briefcase proj-thumb-fallback"></i>
          }
          <span class="proj-name">{{ org.name }}</span>
        </button>
        <i class="bi" [ngClass]="isOrgExpanded(org.id) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
      </li>
      @if (isOrgExpanded(org.id)) {
        <li>
          <ul class="list-unstyled">
            @for (p of getProjectsForOrganization(org.id); track p.id) {
              <li>
                <button class="dropdown-item d-flex align-items-center gap-2" type="button" (click)="selectProject(p)" [class.active]="selectedProject?.id === p.id">
                  @if (p.logoUrl) {
                    <img [src]="p.logoUrl" alt="logo" class="proj-thumb" />
                  } @else {
                    <i class="bi bi-image proj-thumb-fallback"></i>
                  }
                  <span class="proj-name">{{ p.name }}</span>
                </button>
              </li>
            }
          </ul>
        </li>
      }
      @if (org !== organizations()[organizations().length - 1]) {
        <li><hr class="dropdown-divider" /></li>
      }
    }
    @if (organizations().length > 0) {
      <li><hr class="dropdown-divider" /></li>
    }
    @if (getUnmappedProjects().length > 0) {
      <li class="dropdown-header d-flex align-items-center justify-content-between">
        <button type="button" class="btn btn-link p-0 d-flex align-items-center gap-2" disabled>
          <i class="bi bi-folder proj-thumb-fallback"></i>
          <span class="proj-name">Unassigned</span>
        </button>
      </li>
      <li>
        <ul class="list-unstyled">
          @for (p of getUnmappedProjects(); track p.id) {
            <li>
              <button class="dropdown-item d-flex align-items-center gap-2" type="button" (click)="selectProject(p)" [class.active]="selectedProject?.id === p.id">
                @if (p.logoUrl) {
                  <img [src]="p.logoUrl" alt="logo" class="proj-thumb" />
                } @else {
                  <i class="bi bi-image proj-thumb-fallback"></i>
                }
                <span class="proj-name">{{ p.name }}</span>
              </button>
            </li>
          }
        </ul>
      </li>
      <li><hr class="dropdown-divider" /></li>
    }
    <li>
      <button class="dropdown-item add-button d-flex align-items-center gap-2 mt-2" type="button" (click)="navToNewOrganization()">
        <i class="bi bi-plus-circle"></i>
        <span class="ms-2">New Organization</span>
      </button>
    </li>
    <li>
      <button class="dropdown-item add-button d-flex align-items-center gap-2" type="button" (click)="navToNewProject()">
        <i class="bi bi-plus-circle"></i>
        <span class="ms-2">New Project</span>
      </button>
    </li>
  </ul>
</div>
